import React from 'react';
import {
  ActivityIndicator,
  TouchableOpacity,
  type TouchableOpacityProps,
} from 'react-native';
import Text from '../Text';
import { twMerge } from 'tailwind-merge';
import { isWeb } from '~/utils/device';
import colors from '~/assets/themes/colors';

interface Props extends TouchableOpacityProps {
  className?: string;
  variant?: 'primary' | 'secondary' | 'tertiary';
  loading?: boolean;
  children: React.ReactNode;
}

const Button = ({
  className,
  variant = 'primary',
  loading,
  children,
  ...rest
}: Props) => {
  const disabled = rest.disabled || loading;

  if (variant === 'secondary') {
    return (
      <TouchableOpacity
        activeOpacity={0.6}
        className={twMerge(
          'bg-light-100 p-4 sm:py-4 sm:px-2 rounded-lg border',
          disabled
            ? 'border-gray-300'
            : `hover:bg-primary-100 ${
                isWeb ? 'active:bg-primary-200' : ''
              } border-primary-600`,
          className
        )}
        {...rest}
      >
        <Text
          className={twMerge(
            'text-center font-medium text-xs',
            disabled ? 'text-gray-300' : 'text-primary-600'
          )}
        >
          {loading ? (
            <ActivityIndicator color={colors.primary[600]} />
          ) : (
            children
          )}
        </Text>
      </TouchableOpacity>
    );
  }

  if (variant === 'tertiary') {
    return (
      <TouchableOpacity
        activeOpacity={0.6}
        className={twMerge(
          'bg-light-100 p-4 sm:py-4 sm:px-2 rounded-lg',
          disabled
            ? ''
            : `hover:bg-primary-100 ${isWeb ? 'active:bg-primary-200' : ''}`,
          className
        )}
        {...rest}
      >
        <Text
          className={twMerge(
            'text-center font-medium text-xs',
            disabled ? 'text-gray-300' : 'text-primary-600'
          )}
        >
          {loading ? (
            <ActivityIndicator color={colors.primary[600]} />
          ) : (
            children
          )}
        </Text>
      </TouchableOpacity>
    );
  }

  return (
    <TouchableOpacity
      activeOpacity={0.6}
      className={twMerge(
        'bg-primary-600 p-4 rounded-lg',
        disabled
          ? 'bg-gray-300'
          : `hover:bg-primary-500 ${isWeb ? 'active:bg-red-700' : ''}`,
        className
      )}
      {...rest}
    >
      <Text className="text-center uppercase text-white font-medium text-xs">
        {loading ? <ActivityIndicator color={colors.light[100]} /> : children}
      </Text>
    </TouchableOpacity>
  );
};

export default Button;
